import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGeneric from "../../../../layout/navigation/buttons/generic";
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click";
import MainMenu_Settings from "../../../../layout/menu/sections/settings/settings";
import SettingsSearch from "../../../../layout/search/sections/settings/settings-search";
import {GroupedData} from "../../../data-structures/group";

export class SpaceSettings extends SpaceProto {



    constructor() {
        super(NavigationSectionType.SETTINGS)

        this.title = "Settings"

        this.svgIcon    = 'isvg-settings'
    }

    get enabled(): boolean {
        return gd.ac.components.hasAccess('settings')
    }

    get navigationStructureConfig() {

        return {
            id              : this.id,
            icon            : "i5-nav-settings",
            iconActive      : "i5-nav-settings-solid",
            type            : NavigationSectionType.SETTINGS,
            hint            : "Settings",
            renderComponent : Navigation_ButtonGeneric,
            menuComponent   : MainMenu_Settings,
            onClick         : navigationStructureOnClick,
            position        : NavigationButtonPosition.STATIC
        }
    }

    search(keyword:string): GroupedData {
        return new SettingsSearch(true, true, true).searchAndGroup(keyword)
    }



}
